module.exports = __webpack_public_path__ + "f23b0946a1d907ecbefa7b96f915993b.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-24.cur
// module id = 448
// module chunks = 0